import { StyleSheet } from 'aphrodite';
import {
	brandPrimaryHover,
	brandPrimaryText,
	brandSecondaryHover,
	connectionStatusText,
	destructive,
	header,
	label,
	midGray,
	navigation,
	success,
	titles,
	warningDark,
	white,
} from '../../../styles/colors';
import { BrowserMediaQueries, CssSelectors, Layouts, baseStyleSheet, truncateTextStyle } from '../../../styles/styles';

const colSpacing = 10;
const connectionColWidthPrecent = 40;
const borderBottom = `1px ${midGray} solid`;

export const styleSheet = StyleSheet.create({
	alertContainer: {
		alignItems: 'center',
		display: 'flex',
		marginTop: 4,
	},
	alertMessage: {
		color: destructive,
		paddingLeft: 2,
	},
	body: {
		minHeight: 100,
		position: 'relative',
	},
	checkmarkIconRow: {
		alignItems: 'center',
		display: 'flex',
		height: 28,
		...truncateTextStyle,
	},
	clearFiltersContainer: {
		alignItems: 'flex-end',
		display: 'flex',
		height: 40,
		...CssSelectors.allChildren(
			{
				color: header,
			},
			'button'
		),
	},
	connectionRow: {
		alignItems: 'center',
		display: 'flex',
		paddingLeft: 10,
	},
	connectionStatus: {
		alignItems: 'center',
		color: connectionStatusText,
		display: 'flex',
		fontSize: 16,
		marginLeft: 4,
	},
	dateText: {
		color: titles,
	},
	detailed: {
		color: brandPrimaryHover,
		fontSize: 12,
		marginTop: 4,
		width: 120,
	},
	filter: {
		alignItems: 'center',
		color: header,
		display: 'flex',
		fontSize: 14,
		justifyContent: 'flex-end',
		marginBottom: 20,
		marginTop: 10,
		width: '100%',
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
				marginRight: 10,
			},
			':first-child'
		),
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
				marginRight: 20,
			},
			':last-child'
		),
	},
	filterDropdownMenu: {
		fontSize: 14,
	},
	filterDropdownTrigger: {
		background: white,
		color: header,
		fontSize: 14,
		width: 180,
	},
	header: {
		...Layouts.horizontalStack(colSpacing),
		alignItems: 'center',
		borderBottom,
		boxSizing: 'border-box',
		display: 'flex',
		maxWidth: '100%',
		paddingBottom: 6,
	},
	icon: {
		marginRight: 4,
	},
	loading: {
		marginTop: 10,
	},
	nameColumn: {
		width: `calc(${100 - connectionColWidthPrecent - 20}% - ${colSpacing / 2}px)`,
	},
	nameColumnRow: {
		alignItems: 'center',
		color: brandPrimaryText,
		display: 'flex',
	},
	noneFound: {
		color: navigation,
		letterSpacing: 1.1,
		marginTop: 50,
		textAlign: 'center',
		textTransform: 'uppercase',
	},
	platformAccounts: {
		display: 'flex',
		flexDirection: 'column',
	},
	platformColumn: {
		width: `calc(${connectionColWidthPrecent}% - ${colSpacing / 2}px)`,
	},
	platformIconRow: {
		alignItems: 'center',
		display: 'flex',
		minHeight: 28,
		...CssSelectors.allChildren(
			{
				height: 16,
				marginRight: 2,
			},
			'img'
		),
	},
	platformText: {
		fontSize: 16,
	},
	popover: {
		display: 'inline-flex',
		margin: 0,
	},
	popoverWarning: {
		borderBottomRightRadius: 0,
		boxSizing: 'border-box',
		color: label,
		fontSize: 12,
		lineHeight: '18px',
		maxWidth: 180,
		padding: '6px 6px 6px 6px',
	},
	popoverAnchor: {
		marginLeft: 4,
	},
	popoverContent: {
		borderRadius: 3,
		color: titles,
		fontSize: 12,
		padding: '2px 6px',
		width: 210,
	},
	popoverMargin: {
		alignItems: 'center',
		display: 'flex',
	},
	reconnect: {
		color: destructive,
		marginLeft: -4,
	},
	reconnectButton: {
		flexGrow: 1,
		marginTop: 4,
		maxWidth: 200,
		paddingBottom: 2,
		paddingLeft: 4,
		paddingRight: 4,
		paddingTop: 2,
		[BrowserMediaQueries.IE11]: {
			flexGrow: 0,
		},
	},
	reconnectColumn: {
		width: '10%',
	},
	row: {
		alignItems: 'flex-start',
		borderBottom,
		boxSizing: 'border-box',
		display: 'flex',
		maxWidth: '100%',
		padding: '20px 0',
	},
	rowClipboardParent: {
		cursor: 'pointer',
		display: 'flex',
	},
	rowConnection: {
		alignItems: 'center',
		display: 'flex',
		paddingLeft: 10,
	},
	rowDetails: {
		color: navigation,
		fontSize: 11,
	},
	rowDetailsRow: {
		alignItems: 'center',
		display: 'flex',
	},
	rowDetailsStatus: {
		...baseStyleSheet.fontBold,
		textTransform: 'uppercase',
	},
	rowName: {
		width: '100%',
		...Layouts.verticalStack(8),
		...CssSelectors.allChildren(
			{
				fontWeight: 600,
				width: '100%',
			},
			'button'
		),
	},
	rowResponses: {
		alignItems: 'center',
		display: 'flex',
		paddingLeft: 10,
	},
	rowTitle: {
		alignItems: 'center',
		display: 'flex',
		gap: '0.5rem',
	},
	statusCancelled: {
		color: destructive,
	},
	statusFailed: {
		color: destructive,
	},
	statusPending: {
		color: warningDark,
	},
	statusScheduled: {
		color: brandSecondaryHover,
	},
	statusSucceeded: {
		color: success,
	},
	targetRows: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		width: 180,
	},
});
